import {DemandValidation} from "../constants/DemandValidation";
import {isDemandPreparing} from "./getDemandStatus";
import {DemandValidationSectionStatus} from "../constants/DemandValidationSectionStatus";
import NationalNoticeStatus from "../components/complex/nationalNotice/constants/NationalNoticeStatus";

export default (demandValidation, waitingForPublication, bzpContractNoticeStatus) => {
    if (!isDemandPreparing() || !waitingForPublication) {
        return false;
    }

    const notice = demandValidation.find((x) => x.section === DemandValidation.NOTICE);
    if (notice?.status !== DemandValidationSectionStatus.UNAVAILABLE) {
        return false;
    }

    const nationalNotice = demandValidation.find((x) => x.section === DemandValidation.NATIONAL_NOTICE);
    if (!!nationalNotice && nationalNotice.status !== DemandValidationSectionStatus.UNAVAILABLE && bzpContractNoticeStatus && bzpContractNoticeStatus.status !== NationalNoticeStatus.NONE
            && bzpContractNoticeStatus.status !== NationalNoticeStatus.DRAFT && bzpContractNoticeStatus.status !== NationalNoticeStatus.COMPLETED)
        return false;

    return true;
}
